import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "student-details-expanded" }
const _hoisted_2 = { class: "details-container" }
const _hoisted_3 = { class: "date-controls log-filters-compact mb-3" }
const _hoisted_4 = { class: "row g-1 align-items-end" }
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = { class: "col-md-5" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-block mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "details-skeleton"
}
const _hoisted_11 = { class: "card mt-4" }
const _hoisted_12 = { class: "card-body p-0" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table mb-0" }
const _hoisted_15 = { class: "alert alert-danger" }
const _hoisted_16 = { class: "mb-0 mt-1" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "data-content" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "card mb-4" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 0,
  class: "details-grid"
}
const _hoisted_25 = { class: "detail-section" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "small text-muted" }
const _hoisted_28 = { class: "small" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_30 = { class: "detail-section mt-3" }
const _hoisted_31 = { class: "d-flex justify-content-between" }
const _hoisted_32 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_33 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_34 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_35 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_36 = { class: "col-lg-6" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_39 = { class: "badge bg-primary" }
const _hoisted_40 = { class: "card-body p-0" }
const _hoisted_41 = { class: "booking-metrics p-3" }
const _hoisted_42 = {
  key: 0,
  class: "bookings-list"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "d-flex justify-content-between" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "small text-muted" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { class: "badge bg-secondary" }
const _hoisted_49 = { class: "small text-muted mt-1" }
const _hoisted_50 = {
  key: 1,
  class: "p-3 text-muted"
}
const _hoisted_51 = {
  key: 0,
  class: "card mt-4"
}
const _hoisted_52 = { class: "card-header" }
const _hoisted_53 = { class: "text-muted small mb-0 mt-1" }
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = {
  key: 0,
  class: "chart-placeholder"
}
const _hoisted_56 = {
  key: 1,
  class: "chart-error"
}
const _hoisted_57 = {
  key: 1,
  class: "card mt-4"
}
const _hoisted_58 = { class: "card-header" }
const _hoisted_59 = { class: "text-muted small mb-0 mt-1" }
const _hoisted_60 = { class: "card-body p-0" }
const _hoisted_61 = { class: "table-responsive" }
const _hoisted_62 = { class: "table table-striped mb-0" }

import { ref, computed } from 'vue';
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from "echarts/components";
import VChart from "vue-echarts";
import { useQuery } from '@tanstack/vue-query';
import { fetchUserBookings, fetchStudentDetails } from '../../../../api/queries/accountQueries.js';
import { useMasterDataQuery } from '../../../../api';
import { queryKeys } from '../../../../api/queryKeys.js';
import { useBookingActions } from '../../../../composables/useBookingActions.js';
import { format, isValid, parseISO } from 'date-fns';
import { tz } from '@date-fns/tz';
import UserBookingMetrics from '../components/UserBookingMetrics.vue';
import StudentPendingPointReturns from './StudentPendingPointReturns.vue';
import StudentBookingGroups from './StudentBookingGroups.vue';
import StudentAccessibleRooms from './StudentAccessibleRooms.vue';


export default {
  __name: 'StudentDetailsExpanded',
  props: {
  student: {
    type: Object,
    required: true
  },
  defaultFromDate: {
    type: Date,
    required: true
  },
  defaultUntilDate: {
    type: Date,
    required: true
  }
},
  setup(__props) {

const berlinTz = tz('Europe/Berlin');

// Register ECharts components (tree-shaking)
use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
]);

// Props
const props = __props;

// Date range controls
const fromDateInput = ref(format(props.defaultFromDate, 'yyyy-MM-dd', { in: berlinTz }));
const untilDateInput = ref(format(props.defaultUntilDate, 'yyyy-MM-dd', { in: berlinTz }));
const appliedFromDate = ref(fromDateInput.value);
const appliedUntilDate = ref(untilDateInput.value);
const dateError = ref('');

// Chart loading and error states
const isLoadingBudgetHistory = ref(false);
const errorBudgetHistory = ref(null);

// Create computed query key for bookings that reacts to date changes
const bookingsQueryKey = computed(() => queryKeys.accountUserBookings({
  studentId: props.student.id,
  from: appliedFromDate.value,
  until: appliedUntilDate.value
}));

// Validate date range
const validateDateRange = () => {
  const from = fromDateInput.value ? parseISO(fromDateInput.value) : new Date(NaN);
  const until = untilDateInput.value ? parseISO(untilDateInput.value) : new Date(NaN);
  
  if (!isValid(from) || !isValid(until)) {
    dateError.value = 'Bitte geben Sie gültige Datumsangaben ein.';
    return false;
  }
  
  if (until < from) {
    dateError.value = 'Das Enddatum muss nach dem Startdatum liegen.';
    return false;
  }
  
  dateError.value = '';
  return true;
};

// Fetch bookings data
const {
  data: bookings,
  isPending: isPendingBookings,
  isFetching: isFetchingBookings,
  error: bookingsError,
  refetch: refetchBookings
} = useQuery({
  queryKey: bookingsQueryKey,
  queryFn: () => {
    if (!validateDateRange()) {
      return Promise.reject(new Error('Ungültiger Datumsbereich'));
    }
    
    return fetchUserBookings({
      studentId: props.student.id,
      from: appliedFromDate.value,
      until: appliedUntilDate.value
    });
  },
  enabled: true,
  staleTime: 5 * 60 * 1000, // 5 minutes
});

// Fetch student details
const {
  data: studentDetails,
  isPending: isPendingDetails,
  isFetching: isFetchingDetails,
  error: detailsError,
  refetch: refetchDetails
} = useQuery({
  queryKey: queryKeys.accountStudentDetails({ studentId: props.student.id }),
  queryFn: () => fetchStudentDetails({ studentId: props.student.id }),
  enabled: true,
  staleTime: 5 * 60 * 1000, // 5 minutes
});

const { data: masterData } = useQuery(useMasterDataQuery());
const isInitialLoading = computed(
  () => (isPendingBookings.value && !bookings.value)
    || (isPendingDetails.value && !studentDetails.value),
);
const isRefreshingData = computed(
  () => isFetchingBookings.value || isFetchingDetails.value,
);

const budgetHistoryDisclaimer = computed(() => {
  const mode = studentDetails.value?.budgetHistoryMeta?.mode;
  const modeHint = mode === 'retrospective' ? 'Modus: Rückrechnung. ' : '';
  return `${modeHint}Vergangene Tage: Stand Tagesende, heute: aktueller Stand. `
    + 'Berechnet aus den jetzt gespeicherten Einträgen. '
    + 'Änderungen und Stornos wirken rückwirkend.';
});
const bookingActions = useBookingActions();

// Refresh all data
const refreshData = () => {
  if (validateDateRange()) {
    const hasDateChanged = appliedFromDate.value !== fromDateInput.value
      || appliedUntilDate.value !== untilDateInput.value;

    appliedFromDate.value = fromDateInput.value;
    appliedUntilDate.value = untilDateInput.value;

    if (!hasDateChanged) {
      refetchBookings();
      refetchDetails();
    }
  }
};

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return '-';
  if (dateString.length === 10 && dateString[4] === '-' && dateString[7] === '-') {
    const parsed = parseISO(dateString);
    return isValid(parsed) ? format(parsed, 'dd.MM.yyyy') : 'Invalid Date';
  }
  const date = new Date(dateString);
  return isValid(date) ? format(date, 'dd.MM.yyyy') : 'Invalid Date';
};

// Format time for display
const formatTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return isValid(date) ? format(date, 'HH:mm') : 'Invalid Date';
};

const pendingPointReturns = computed(() => studentDetails.value?.pendingPointReturns ?? []);
const bookingGroups = computed(() => studentDetails.value?.bookingGroups ?? []);
const accessibleRooms = computed(() => studentDetails.value?.accessibleRooms ?? []);

const formatRoomLabel = (booking) => {
  const building = booking?.room?.buildingShort;
  const door = booking?.room?.doorLabel;

  if (building && door) {
    return `${building} - ${door}`;
  }

  return building || door || '-';
};

const formatBookingTypeLabel = (booking) => {
  const bookingTypeId = booking?.bookingTypeId;
  const bookingType = bookingTypeId
    ? masterData.value?.bookingTypes?.list?.[bookingTypeId]
    : null;

  if (bookingType?.title) {
    return bookingType.title;
  }

  if (bookingTypeId) {
    return `Typ ${bookingTypeId}`;
  }

  return 'Unbekannt';
};

const openBookingDetails = (booking) => {
  if (!booking?.id) return;
  bookingActions.viewBooking(booking);
};

// Chart option for budget history
const budgetHistoryChartOption = computed(() => {
  if (!studentDetails.value?.budgetHistory || studentDetails.value.budgetHistory.length === 0) {
    return {};
  }

  // Sort by date to ensure proper order
  const sortedHistory = [...studentDetails.value.budgetHistory].sort((a, b) => {
    return parseISO(a.date) - parseISO(b.date);
  });

  const dates = sortedHistory.map(entry => formatDate(entry.date));
  const totalPoints = sortedHistory.map(entry => entry.total);
  const usedPoints = sortedHistory.map(entry => entry.used);
  const availablePoints = sortedHistory.map(entry => entry.total - entry.used);
  const allValues = [...totalPoints, ...usedPoints, ...availablePoints];
  const minValue = Math.min(...allValues);
  const maxValue = Math.max(...allValues);
  const isFlatRange = minValue === maxValue;
  const yAxisMin = isFlatRange
    ? minValue - (maxValue === 0 ? 0.2 : Math.max(Math.abs(maxValue) * 0.2, 1))
    : Math.floor(minValue * (minValue >= 0 ? 0.95 : 1.05));
  const yAxisMax = isFlatRange
    ? (maxValue === 0 ? 0.2 : maxValue + Math.max(Math.abs(maxValue) * 0.2, 1))
    : Math.ceil(maxValue * 1.05);

  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['Total', 'Verbraucht', 'Verfügbar'],
      top: 4,
      left: 'center'
    },
    grid: {
      left: '3%',
      right: '4%',
      top: 36,
      bottom: 56,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: dates,
      axisLabel: {
        margin: 14,
        hideOverlap: true,
      },
    },
    yAxis: {
      type: 'value',
      min: yAxisMin,
      max: yAxisMax,
    },
    series: [
      {
        name: 'Total',
        type: 'line',
        data: totalPoints,
        smooth: true,
        itemStyle: {
          color: '#409eff'
        }
      },
      {
        name: 'Verbraucht',
        type: 'line',
        data: usedPoints,
        smooth: true,
        itemStyle: {
          color: '#e6a23c'
        }
      },
      {
        name: 'Verfügbar',
        type: 'line',
        data: availablePoints,
        smooth: true,
        itemStyle: {
          color: '#67c23a'
        }
      }
    ]
  };
});



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Date Range Controls "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "from-date",
              class: "form-label-sm"
            }, "Von", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              id: "from-date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((fromDateInput).value = $event)),
              type: "date",
              class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': dateError.value }])
            }, null, 2 /* CLASS */), [
              [_vModelText, fromDateInput.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "until-date",
              class: "form-label-sm"
            }, "Bis", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              id: "until-date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((untilDateInput).value = $event)),
              type: "date",
              class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': dateError.value }])
            }, null, 2 /* CLASS */), [
              [_vModelText, untilDateInput.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm w-100",
              disabled: dateError.value || isRefreshingData.value,
              onClick: refreshData
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-sync-alt me-1", { 'fa-spin': isRefreshingData.value }])
              }, null, 2 /* CLASS */),
              _cache[4] || (_cache[4] = _createTextVNode(" Aktualisieren ", -1 /* CACHED */))
            ], 8 /* PROPS */, _hoisted_8)
          ])
        ]),
        (dateError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(dateError.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Loading States "),
      (isInitialLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"card mb-3\" data-v-fffa5264><div class=\"card-body\" data-v-fffa5264><div class=\"row g-3\" data-v-fffa5264><div class=\"col-md-6\" data-v-fffa5264><div class=\"skeleton skeleton-label\" data-v-fffa5264></div><div class=\"skeleton skeleton-input\" data-v-fffa5264></div></div><div class=\"col-md-6\" data-v-fffa5264><div class=\"skeleton skeleton-label\" data-v-fffa5264></div><div class=\"skeleton skeleton-input\" data-v-fffa5264></div></div></div></div></div><div class=\"row g-3\" data-v-fffa5264><div class=\"col-lg-6\" data-v-fffa5264><div class=\"card\" data-v-fffa5264><div class=\"card-header\" data-v-fffa5264><div class=\"skeleton skeleton-title\" data-v-fffa5264></div></div><div class=\"card-body\" data-v-fffa5264><div class=\"skeleton skeleton-line\" data-v-fffa5264></div><div class=\"skeleton skeleton-line w-75\" data-v-fffa5264></div><div class=\"skeleton skeleton-line w-50\" data-v-fffa5264></div></div></div></div><div class=\"col-lg-6\" data-v-fffa5264><div class=\"card\" data-v-fffa5264><div class=\"card-header\" data-v-fffa5264><div class=\"skeleton skeleton-title\" data-v-fffa5264></div></div><div class=\"card-body\" data-v-fffa5264><div class=\"skeleton skeleton-line\" data-v-fffa5264></div><div class=\"skeleton skeleton-line w-75\" data-v-fffa5264></div><div class=\"skeleton skeleton-line w-50\" data-v-fffa5264></div></div></div></div></div><div class=\"card mt-4\" data-v-fffa5264><div class=\"card-header\" data-v-fffa5264><div class=\"skeleton skeleton-title\" data-v-fffa5264></div></div><div class=\"card-body\" data-v-fffa5264><div class=\"skeleton skeleton-chart\" data-v-fffa5264></div></div></div>", 3)),
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("div", { class: "skeleton skeleton-title" })
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("table", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                          _createElementVNode("div", { class: "skeleton skeleton-header" })
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("div", { class: "skeleton skeleton-header" })
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("div", { class: "skeleton skeleton-header" })
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("div", { class: "skeleton skeleton-header" })
                        ])
                      ])
                    ], -1 /* CACHED */)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                        return _createElementVNode("tr", { key: n }, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "skeleton skeleton-cell" })
                          ], -1 /* CACHED */),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "skeleton skeleton-cell" })
                          ], -1 /* CACHED */),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "skeleton skeleton-cell" })
                          ], -1 /* CACHED */),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "skeleton skeleton-cell" })
                          ], -1 /* CACHED */)
                        ]))])
                      }), 64 /* STABLE_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (_unref(bookingsError) || _unref(detailsError))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Error States "),
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                _cache[10] || (_cache[10] = _createTextVNode(" Fehler beim Laden der Daten: ", -1 /* CACHED */)),
                _createElementVNode("ul", _hoisted_16, [
                  (_unref(bookingsError))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_unref(bookingsError).message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_unref(detailsError))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(_unref(detailsError).message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Data Content "),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createCommentVNode(" Student Details "),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", { class: "card-title mb-0" }, " Studentendetails ")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_23, [
                        (_unref(studentDetails))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createCommentVNode(" Enrolments "),
                              _createElementVNode("div", _hoisted_25, [
                                _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "text-muted section-title" }, " Einschreibungen ", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentDetails).enrolments, (enrolment) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: enrolment.id,
                                    class: "mb-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_26, _toDisplayString(enrolment.program.name), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(enrolment.firstSpecialization?.name || 'Keine Spezialisierung'), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_28, " Semester: " + _toDisplayString(enrolment.currentSemesterCount), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (!_unref(studentDetails).enrolments.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Keine aktiven Einschreibungen "))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createCommentVNode(" Active Budgets "),
                              _createElementVNode("div", _hoisted_30, [
                                _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "text-muted section-title" }, " Aktive Budgets ", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentDetails).activeBudgets, (budget) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: budget.id,
                                    class: "mb-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("span", null, _toDisplayString(budget.points) + " Punkte", 1 /* TEXT */),
                                      (budget.validFrom && budget.validUntil)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(formatDate(budget.validFrom)) + " - " + _toDisplayString(formatDate(budget.validUntil)), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    (budget.comment)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(budget.comment), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (!_unref(studentDetails).activeBudgets.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Keine aktiven Budgets "))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createVNode(StudentPendingPointReturns, {
                                entries: pendingPointReturns.value,
                                "format-date": formatDate,
                                "format-time": formatTime
                              }, null, 8 /* PROPS */, ["entries"]),
                              _createVNode(StudentBookingGroups, { groups: bookingGroups.value }, null, 8 /* PROPS */, ["groups"]),
                              _createVNode(StudentAccessibleRooms, { rooms: accessibleRooms.value }, null, 8 /* PROPS */, ["rooms"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_35, " Keine Details verfügbar "))
                      ])
                    ])
                  ]),
                  _createCommentVNode(" Bookings "),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "card-title mb-0" }, " Raumbuchungen ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(bookings)?.length || 0) + " Buchungen ", 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(UserBookingMetrics, { bookings: _unref(bookings) }, null, 8 /* PROPS */, ["bookings"])
                        ]),
                        (_unref(bookings) && _unref(bookings).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookings), (booking) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: booking.id,
                                  class: "booking-item border-bottom p-3"
                                }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "booking-open-btn",
                                    onClick: $event => (openBookingDetails(booking))
                                  }, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_45, _toDisplayString(booking.title), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_46, _toDisplayString(formatDate(booking.startTime)) + ", " + _toDisplayString(formatTime(booking.startTime)) + " - " + _toDisplayString(formatTime(booking.endTime)), 1 /* TEXT */)
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(formatBookingTypeLabel(booking)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_49, _toDisplayString(formatRoomLabel(booking)), 1 /* TEXT */)
                                      ])
                                    ])
                                  ], 8 /* PROPS */, _hoisted_43)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_50, " Keine Buchungen im ausgewählten Zeitraum "))
                      ])
                    ])
                  ])
                ]),
                _createCommentVNode(" Budget History Chart "),
                (_unref(studentDetails)?.budgetHistory && _unref(studentDetails).budgetHistory.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title mb-0" }, " Budget-Rückrechnung ", -1 /* CACHED */)),
                        _createElementVNode("p", _hoisted_53, _toDisplayString(budgetHistoryDisclaimer.value), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        (isLoadingBudgetHistory.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("div", {
                                class: "spinner-border text-primary",
                                role: "status"
                              }, [
                                _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
                              ], -1 /* CACHED */),
                              _createElementVNode("p", { class: "mt-2" }, " Diagramm wird geladen... ", -1 /* CACHED */)
                            ]))]))
                          : (errorBudgetHistory.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                                _createTextVNode(" Fehler beim Laden des Diagramms: " + _toDisplayString(errorBudgetHistory.value.message), 1 /* TEXT */)
                              ]))
                            : (_openBlock(), _createBlock(_unref(VChart), {
                                key: 2,
                                class: "chart",
                                option: budgetHistoryChartOption.value,
                                autoresize: ""
                              }, null, 8 /* PROPS */, ["option"]))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Budget History Table "),
                (_unref(studentDetails)?.budgetHistory)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "card-title mb-0" }, " Budget-Rückrechnung (letzte 30 Tage) ", -1 /* CACHED */)),
                        _createElementVNode("p", _hoisted_59, _toDisplayString(budgetHistoryDisclaimer.value), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("table", _hoisted_62, [
                            _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Datum"),
                                _createElementVNode("th", null, "Total"),
                                _createElementVNode("th", null, "Verbraucht"),
                                _createElementVNode("th", null, "Verfügbar")
                              ])
                            ], -1 /* CACHED */)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studentDetails).budgetHistory, (entry, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(formatDate(entry.date)), 1 /* TEXT */),
                                  _createElementVNode("td", null, _toDisplayString(entry.total) + " Punkte", 1 /* TEXT */),
                                  _createElementVNode("td", null, _toDisplayString(entry.used) + " Punkte", 1 /* TEXT */),
                                  _createElementVNode("td", null, _toDisplayString(entry.total - entry.used) + " Punkte", 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ])
  ]))
}
}

}